export const getRange = (count: number) => {
  return Array.from({ length: count }, (_, i) => i);
};
